import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const theme = "system"

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        duration: 3000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:rounded-[12px] group-[.toaster]:shadow-md group-[.toaster]:border-l-[3px]",
          title: "group-[.toast]:text-[13px] group-[.toast]:font-medium",
          description: "group-[.toast]:text-[12.5px] group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-surface-2 group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-l-good [&_[data-icon]]:text-good",
          error: "group-[.toaster]:border-l-critical [&_[data-icon]]:text-critical",
          warning: "group-[.toaster]:border-l-warning [&_[data-icon]]:text-warning",
          info: "group-[.toaster]:border-l-primary [&_[data-icon]]:text-primary",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
